import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  Menu,
  MenuItem,
  IconButton,
  CssBaseline,
  AppBar,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@material-ui/core";
import store from "../Redux/Store";
import "./Sidebar.css";
import { MoreVert } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import { routeConfigList, Routes } from "./RouteContent";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  Link,
} from "react-router-dom";
import { fetchMethod } from "../FetchMethod";
import pdfimage from "../assets/pdf.png";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { API_URL } from "../Config";
import SnackBarComponent from "../SnackBar/SnackBar";
import { FadeLoader } from "react-spinners";
function MiniDrawer(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [Pdf, setPdf] = React.useState(null);
  const [openModal, setopenModal] = React.useState(false);
  const [selectPdf, setselectPdf] = React.useState(undefined);
  const [disableViewpdf, setdisableViewpdf] = React.useState(false);
  const [successMessage, setMessage] = React.useState({
    open: false,
    severity: "",
    alertmsg: "",
    loading: false,
    isFileUpload: false,
  });
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const isPdfOpen = Boolean(Pdf);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handlePdfClose = () => {
    setPdf(null);
  };
  /************************Timer for 25 minutes *****************************/
  useEffect(() => {
    let timeLeftVar = secondsToTime(store.getState().seconds);
    secondsToTime(store.getState().seconds);
    store.dispatch({ type: "Time", time: timeLeftVar });
    startTimer();
  }, []);
//   useEffect(() => {
//     console.log (window.performance.navigation.type, "Window Performance")
//     debugger
//     window.onbeforeunload = confirmExit;
//     function confirmExit()
//     {
//       if (window.performance.navigation.type !==window.performance.navigation.TYPE_RELOAD)
//      localStorage.clear()
//     }
// }, [])
  const { initialMinute = 5, initialSeconds = 0 } = props;
  const [minutes, setMinutes] = React.useState(initialMinute);
  const [seconds, setSeconds] = React.useState(initialSeconds);
  useEffect(() => {
    // Only count down when the session-timeout dialog is actually visible.
    // Without this guard the timer fires handleLogOut() after 5 min regardless
    // of whether the user has seen the warning dialog.
    if (!props.showModal) return;

    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
          handleLogOut();
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  let timer = 0;
  const secondsToTime = (secs) => {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);
    minutes = ("0" + minutes).slice(-2);
    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);
    seconds = ("0" + seconds).slice(-2);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  };
  const startTimer = () => {
    if (timer === 0 && store.getState().seconds > 0) {
      timer = setInterval(countDown, 1000);
    }
  };

  const countDown = () => {
    // Remove one second, set state so a re-render happens.
    let seconds = store.getState().seconds - 1;
    store.dispatch({
      type: "Seconds_Time",
      payload: { time: secondsToTime(seconds), seconds: seconds },
    });

    // Check if we're at zero.
    if (seconds === 0) {
      store.dispatch({ type: "ShowModal", showModal: true });
      clearInterval(timer);
    }
  };
  const handleClose = () => {
    props.showDialogbox(false);
    props.TimeDelay(1500);
    ApiCall();
    setMinutes(5);
    setSeconds(0);
    startTimer();
  };
  const ApiCall = () => {
    fetchMethod(`{
      allSites{
      totalCount
      }
    }`)
      .then((res) => res.json())
      .then((res) => res)
      .catch((e) => console.log(e));
  };
  /*************************************************************/

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogOut = () => {
    let requestOptions = {
      method: "GET",
      headers: {
        access_token: localStorage.getItem("token"),
      },
    };
    fetch(API_URL + '/logout?access_token=' + localStorage.getItem("token"), requestOptions)
      .then((response) => {
		localStorage.clear();
		window.location = "/";
      })
      .catch((e) =>{
		localStorage.clear();
		window.location = "/";
	  });
  };

  const menuId = "primary-search-account-menu";
  const handlePdf = (event) => {
    setPdf(event.currentTarget);
  };

  const ModifyPdf = () => {
    setopenModal(true);
    setPdf(null);
  };
  const handleClosePdf = () => {
    setopenModal(false);
    setselectPdf(undefined);
  };
  const clearPdf = () => {
    setselectPdf(undefined);
  };
  const uploadPdf = () => {
    setLoading(true);
    if (selectPdf) {
      let formData = new FormData();
      let pdf = new File([selectPdf], "IFU.pdf");
      formData.append("ctscan", pdf);
      let url = API_URL + `/api/Containers/uptake-ctscans/upload?tag=ifu`;
      let issuccess = false;
      var requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow",
        headers: {
          access_token: localStorage.getItem("token"),
        },
      };
      return fetch(url, requestOptions)
        .then((response) => response.json())
        .then((res) => {
          // if (res.status) {
          if (res.result.files.ctscan) {
            setMessage({
              isFileUpload: true,
              open: true,
              severity: "success",
              alertmsg: "IFU file uploaded.",
              loading: false,
            });
            setLoading(false);
            handleClosePdf();
            issuccess = true;
          } else {
            let message = res.error ? res.error.message : res.message;
            setError(message);
            setLoading(false);
            issuccess = false;
          }
          return issuccess;
        })
        .catch((error) => {
          setError(error.message);
          setLoading(false);
          console.log(error);
          issuccess = false;
          return issuccess;
        });
    }
  };
  const handleSnackBarClose = () => {
    setMessage({ open: false, severity: "", alertmsg: "", loading: false });
  };
  const onDrop = (acceptedFile) => {
    setselectPdf(acceptedFile[0]);
  };
  const viewPdf = () => {
    setdisableViewpdf(true);
    let url = API_URL + `/api/Containers/download-files?tag=ifu`;
    var requestOptions = {
      method: "GET",
      headers: {
        access_token: localStorage.getItem("token"),
      },
    };
    fetch(url, requestOptions)
      .then((res) => res.arrayBuffer(8))
      .then((response) => {
        setPdf(null);
        setdisableViewpdf(false);
        var file = new Blob([response], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");
      })
      .catch((e) => console.log(e));
  };
  const renderPdf = (
    <div>
      <Menu
        anchorEl={Pdf}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isPdfOpen}
        onClose={handlePdfClose}
      >
        <MenuItem onClick={viewPdf} disabled={disableViewpdf}>
          View
        </MenuItem>
        <MenuItem onClick={ModifyPdf}>Modify</MenuItem>
      </Menu>
    </div>
  );
  const renderMenu = (
    <div>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={(handleMenuClose, handleLogOut)}>Log Out</MenuItem>
      </Menu>
    </div>
  );
const footerStyle= {
  padding: "10px 0px",
  textAlign: "center"
}
  return (
    <Router>
      {loading ? (
        <div className="Loader">
          <FadeLoader
            style={{ height: "15", width: "5", radius: "2" }}
            color={"#6FABF0"}
            loading={loading}
          />
        </div>
      ) : (
        ""
      )}
      {successMessage.open ? (
        <SnackBarComponent
          severity={successMessage.severity}
          open={successMessage.open}
          alertmsg={successMessage.alertmsg}
          handleClose={handleSnackBarClose}
          className="addUserSnackBar"
        />
      ) : (
        ""
      )}
      <Dialog
        className="LogoutMessageSession"
        open={props.showModal}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Typography> Session Timeout</Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your online session will expire in
          </DialogContentText>
          {minutes === 0 && seconds === 0 ? null : (
            <h2 className="timerwindow">
              {" "}
              {minutes < 10 ? `0${minutes}` : minutes} min{" "}
              {seconds < 10 ? `0${seconds}` : seconds} secs
            </h2>
          )}
          <p>
            <span>Please click "Continue" to Keep working</span>
            <span>or click "Log Off" to end your sesion now.</span>
          </p>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} className="cancelbtn">
            Continue
          </Button>
          <Button onClick={handleLogOut} autoFocus className="confirmbtn">
            Log Off
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openModal}
        onClose={handleClosePdf}
        aria-labelledby="simple-modal-title"
        ariadescribedby="simple-modal-description"
      >
        <div className="IFUPdfDialog">
          <div>
            <div className="employeeexcelHeader">
              <h5> Upload IFU PDF</h5>
              <span onClick={handleClosePdf}>
                <CloseIcon />
              </span>
            </div>

            <p>Choose a file to upload.</p>
          </div>
          <ul>
            <li>
              <form>
                <input
                  style={{ display: "none" }}
                  accept=".pdf"
                  id="contained-button-file"
                  type="file"
                  onChange={(e) => onDrop(e.target.files)}
                  onClick={(e) => (e.target.value = null)}
                />
                <label htmlFor="contained-button-file">
                  <Button
                    variant="outlined"
                    color="primary"
                    className="btnDvrStatusReport"
                    component="span"
                    startIcon={<AttachFileIcon />}
                  >
                    Browse
                  </Button>
                </label>
              </form>
            </li>
            <li>
              <p>
                <span>{selectPdf ? selectPdf.name : "Browse File"}</span>
                <span>
                  {selectPdf ? (
                    <CloseIcon
                      onClick={clearPdf}
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    ""
                  )}
                </span>
              </p>
            </li>
            <li>
              {selectPdf ? (
                <Button onClick={uploadPdf}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.0"
                    width="10.000000pt"
                    height="10.000000pt"
                    viewBox="0 0 225.000000 225.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                      transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
                      fill="#000000"
                      stroke="none"
                    >
                      <path d="M1085 2240 c-19 -6 -139 -119 -337 -317 -330 -330 -338 -340 -318 -414 5 -19 24 -48 41 -65 27 -26 37 -29 95 -29 l64 0 172 173 c95 94 177 172 181 172 4 0 7 -250 7 -555 l0 -554 31 -36 c59 -66 150 -66 208 1 l31 35 0 554 c0 305 3 555 7 555 4 0 86 -78 181 -172 l172 -173 64 0 c58 0 68 3 96 30 38 36 53 88 40 135 -7 27 -83 108 -323 348 -172 171 -319 312 -327 312 -8 0 -24 2 -35 5 -11 2 -33 0 -50 -5z" />
                      <path d="M84 831 c-35 -15 -72 -69 -79 -114 -4 -23 -5 -171 -3 -329 3 -271 4 -288 24 -314 11 -15 33 -37 48 -48 27 -21 33 -21 1051 -21 1018 0 1024 0 1051 21 15 11 37 33 48 48 20 26 21 43 24 326 2 185 -1 313 -7 337 -6 22 -25 52 -41 68 -28 27 -38 30 -96 30 -61 0 -68 -2 -94 -32 -43 -48 -50 -90 -50 -310 l0 -203 -835 0 -835 0 0 203 c0 219 -7 262 -49 309 -23 26 -36 32 -82 34 -30 2 -63 0 -75 -5z" />
                    </g>
                  </svg>{" "}
                  Upload
                </Button>
              ) : (
                ""
              )}
            </li>
          </ul>
          <p style={{ textAlign: "center", marginTop: "5px", color: "red" }}>
            {error}
          </p>
        </div>
      </Dialog>
      <div>
        <CssBaseline />
        <AppBar position="fixed">
          <div className="logo">
            <h2>
              <span>Uptake</span>Medical<sup>R</sup>
            </h2>
            <span>A Broncus Company</span>
          </div>
          <div className="headerFields">
            <List className="lists">
              {routeConfigList.map((items, index) => (
                <div key={index}>
                  {
                    <div
                      key={index}
                      className={
                        props.sidebarRoute === items.path ? "sidebarColor" : ""
                      }
                    >
                      {items.isVisible ? (
                        <span key={index}>
                          <ListItem
                            button
                            // onClick={sidebarClick}
                            key={items.title}
                            component={Link}
                            onClick={(e) => {
                              if (localStorage.getItem("path") !== items.path) {
                                localStorage.setItem("path", items.path);
                                localStorage.setItem("rows", 10);
                              }
                            }}
                            to={`${items.path}`}
                          >
                            <ListItemText primary={items.title} />
                          </ListItem>
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  }
                </div>
              ))}
            </List>

            <div className="profileSection">
              <div className="profilepart">
                <Avatar>{localStorage.getItem("userInitials")}</Avatar>
                <span>{localStorage.getItem("name")}</span>
              </div>
            </div>
            <div>
              <div className="moreVertIconAndAvatar">
                <IconButton
                  //   edge="end"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  style={{ color: "#004a87" }}
                >
                  <MoreVert />
                </IconButton>
                <IconButton
                  onClick={props.role === "ADMIN" ? handlePdf : viewPdf}
                >
                  <img src={pdfimage} alt="pdf" />
                </IconButton>
              </div>
              {renderMenu}
              {renderPdf}
            </div>
          </div>
        </AppBar>
        {/*****************Footer for Sidebar******************* */}
        {/***********************End**************************** */}
        <div className="mainSection">
          {/* <div className={classes.toolbar} /> */}
          <Switch>
            {Routes.map((route, index) =>
              route.isVisible ? (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  component={route.main}
                />
              ) : (
                ""
              )
            )}
            <Redirect
              to={
                props.role === "ADMIN" ||
                props.role === "ASSISTANT" ||
                props.role === "SALESREP" ||
                props.role === "PHYSICIAN"
                  ? "/sites"
                  : "/patient"
              }
            >
              {/* {localStorage.clear()} */}
            </Redirect>
          </Switch>
          <footer style = {footerStyle}>
          <p>&#169; 2021 Uptake Medical Technology Inc. All Rights Reserved. If you encounter any problems, please contact  <a href="mailto:ip3@uptakemedical.com" target="_blank">ip3@uptakemedical.com</a></p>
          {/* <p><a href="mailto:hege@example.com">hege@example.com</a></p> */}
        </footer>
        </div>
      </div>
    </Router>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showDialogbox: (data) => dispatch({ type: "ShowModal", showModal: data }),
    TimeDelay: (data) => dispatch({ type: "TimeDelay", seconds: data }),
  };
};

const mapStateToProps = (state) => {
  return {
    Header: state.Header,
    sidebarRoute: state.sidebarRoute,
    showModal: state.showModal,
    seconds: state.seconds,
    role: state.role,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniDrawer);
